module.exports = __webpack_public_path__ + "img/login-left.66c50b75.svg";